import { createReduxAsyncThunk } from 'shared/utils';

import dataSources from 'dataSources';

import { BRANDS_STATE } from '../../constants';

import { FavouriteBrand } from '../../types';

export const deleteFavouriteBrands = createReduxAsyncThunk<
  { favouriteBrandBillingIds: FavouriteBrand['billingId'][] },
  FavouriteBrand['billingId'][]
>(
  `${BRANDS_STATE}/deleteFavouriteBrands`,
  async (billingIds) => {
    await dataSources.brands.deleteFavouriteBrands(billingIds);
    return { favouriteBrandBillingIds: billingIds };
  }
);
